import React, { useState } from 'react';
import { StyleSheet, View } from 'react-native';
import Button from './Button.component';
import {
	ButtonPreset,
	ButtonProps,
} from '../../../interfaces/buttonProps.interface';
import colors from '../../../config/colors';

type ButtonSize = 'small' | 'medium';

const sizeStyles: Record<ButtonSize, { button: object; container: object }> = {
	small: {
		button: {
			height: 32,
            minWidth: 100,
			paddingHorizontal: 16,
			paddingVertical: 11,
			//gap: 4,
			borderRadius: 8,
		},
		container: { width: '100%', height: 32 },
	},
	medium: {
		button: {
			height: 40,
            minWidth: 100,
			paddingHorizontal: 12,
			paddingVertical: 11,
			//gap: 8,
			borderRadius: 8,
		},
		container: { width: '100%', height: 40 },
	},
};

const presetStyles: Record<ButtonPreset, { base: object; hover: object }> = {
	primary: {
		base: { backgroundColor: colors.titlePrimary },
		hover: { backgroundColor: colors.primaryDark },
	},
	outline: {
		base: {
			backgroundColor: 'transparent',
			borderWidth: 1,
			borderColor: colors.titlePrimary,
		},
		hover: { backgroundColor: colors.secondaryLight },
	},
	filled: {
		base: { backgroundColor: colors.datepickerChooseBG },
		hover: { backgroundColor: colors.filledHover },
	},
    link: {
		base: { backgroundColor: 'transparent' },
		hover: { backgroundColor: colors.secondaryLight },
	},
	danger: {
		base: { backgroundColor: colors.redClock },
		hover: { backgroundColor: '#b62929' },
	},
    green: {
		base: { backgroundColor: colors.greenClock },
		hover: { backgroundColor: colors.greenClockHover },
	},
	default: {
		base: {},
		hover: { backgroundColor: '#E3F4FF' },
	},
};

const ButtonV2 = ({
	children,
	onPress,
	disabled,
	overrideStyle,
	hoverStyle,
	containerStyle,
	preset = 'default',
	size = 'medium',
}: ButtonProps) => {
	const [hovered, setHovered] = useState(false);

	const { base, hover } = presetStyles[preset];
	const { button: sizeButton, container: sizeContainer } = sizeStyles[size];

	const buttonStyles = StyleSheet.flatten([
		styles.button,
		sizeButton,
		base,
		overrideStyle,
		hovered && !disabled && (hoverStyle || hover),
	]);

	const containerStyles = StyleSheet.flatten([
		styles.actionsContainer,
		sizeContainer,
		containerStyle,
	]);

	return (
		<Button
			buttonStyle={buttonStyles}
			onPress={onPress}
			disabled={disabled}
			onMouseEnter={() => setHovered(true)}
			onMouseLeave={() => setHovered(false)}
		>
			<View style={containerStyles}>{children}</View>
		</Button>
	);
};

const styles = StyleSheet.create({
	button: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	actionsContainer: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'center',
	},
});

export default ButtonV2;
